import { useEffect } from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { WebLayout } from "../../components/web-layout";
import { useLoginURL } from "../queries";

interface Props {
    source: string;
}

export default function Handler({ source }: Props) {
    const {
        isLoading,
        isError,
        isSuccess,
        error,
        data: url,
    } = useLoginURL(source);
    const navigate = useNavigate();

    useEffect(() => {
        if (isSuccess && url) {
            window.location.href = url;
        }
    }, [navigate, isSuccess, url]);

    return (
        <WebLayout>
            <Row className="align-items-center justify-content-center mb-2">
                {isLoading && (
                    <>
                        <Col xs="auto">
                            <Spinner animation="border" variant="secondary" />
                        </Col>
                        <Col xs="auto" className="pl-1">
                            <h4 className="my-0">Fetching url for login...</h4>
                        </Col>
                    </>
                )}
                {isError && !!error && (
                    <Col xs="auto">
                        <h3 className="text-danger">
                            Failed to fetch login URL
                        </h3>
                    </Col>
                )}
                {isSuccess && (
                    <>
                        <Col xs="auto">
                            <Spinner animation="border" variant="secondary" />
                        </Col>
                        <Col xs="auto" className="pl-1">
                            <h4 className="my-0">Redirecting...</h4>
                        </Col>
                    </>
                )}
            </Row>
        </WebLayout>
    );
}
